module.exports = __webpack_public_path__ + "static/media/logo1.92c796ac.svg";